/* Pond Haven collection redesign v2.
   Sticky filter bar behaviour and the Guide & FAQ expander.
   Everything degrades: the pills are native <details>, so the page still
   filters with JS off. This file only adds polish. */
(function () {
  'use strict';

  // Two sections on this template include this file, so it is parsed twice.
  // Binding twice made every toggle fire twice and cancel itself out.
  if (window.__phCollectionV2) return;
  window.__phCollectionV2 = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {
    var bar = document.querySelector('[data-ph-filterbar]');

    /* ---- 1. Park the bar under a fixed header, if the theme has one ---- */
    if (bar) {
      var measureTop = function () {
        var top = 0;
        var header = document.querySelector('.page__header, header');
        if (header) {
          var pos = window.getComputedStyle(header).position;
          if (pos === 'fixed' || pos === 'sticky') top = header.offsetHeight;
        }
        document.documentElement.style.setProperty('--ph-v2-sticky-top', top + 'px');
        return top;
      };
      var stickyTop = measureTop();
      window.addEventListener('resize', function () { stickyTop = measureTop(); });

      /* Shadow once the bar is actually pinned. The sentinel sits inside the
         sticky wrapper, so it pins too and an IntersectionObserver never fires;
         compare the bar's own offset instead. */
      var section = bar.parentElement;
      var syncStuck = function () {
        section.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= stickyTop + 1);
      };
      syncStuck();
      window.addEventListener('scroll', syncStuck, { passive: true });
      window.addEventListener('resize', syncStuck);
    }

    /* ---- 2. One pill open at a time, close on outside click or Escape ---- */
    var pills = Array.prototype.slice.call(document.querySelectorAll('[data-ph-fb-pill]'));

    var placePanel = function (pill) {
      var panel = pill.querySelector('.ph-fb__panel');
      if (!panel) return;
      // Desktop: flip the panel to right-aligned when it would run off screen.
      pill.classList.remove('ph-fb__pill--right');
      if (window.innerWidth > 860) {
        var r = pill.getBoundingClientRect();
        if (r.left + panel.offsetWidth > window.innerWidth - 16) pill.classList.add('ph-fb__pill--right');
      } else if (bar) {
        // Mobile: the rail scrolls horizontally and would clip an absolute panel,
        // so the panel is fixed and positioned just below the bar.
        panel.style.top = (bar.getBoundingClientRect().bottom + 8) + 'px';
      }
    };

    pills.forEach(function (pill) {
      pill.addEventListener('toggle', function () {
        if (!pill.open) return;
        pills.forEach(function (other) { if (other !== pill) other.open = false; });
        placePanel(pill);
      });
    });

    document.addEventListener('click', function (e) {
      pills.forEach(function (pill) {
        if (pill.open && !pill.contains(e.target)) pill.open = false;
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      pills.forEach(function (pill) {
        if (!pill.open) return;
        pill.open = false;
        var s = pill.querySelector('summary');
        if (s) s.focus();
      });
    });

    /* ---- 3. Price apply ---- */
    var apply = document.querySelector('[data-ph-price-apply]');
    if (apply) {
      apply.addEventListener('click', function () {
        var param = apply.getAttribute('data-param');
        var min = document.getElementById('phV2PriceMin');
        var max = document.getElementById('phV2PriceMax');
        var url = new URL(window.location.href);
        if (min && min.value) url.searchParams.set(param + '.gte', min.value);
        else url.searchParams.delete(param + '.gte');
        if (max && max.value) url.searchParams.set(param + '.lte', max.value);
        else url.searchParams.delete(param + '.lte');
        window.location.href = url.toString();
      });
    }

    /* ---- 4. Grid / list view toggle (v1 markup is class-compatible) ---- */
    var grid = document.querySelector('.product__list.row--product');
    var views = document.querySelector('[data-ph-view-toggle]');
    if (grid && views) {
      var stored = null;
      try { stored = window.localStorage.getItem('ph-coll-view'); } catch (err) { stored = null; }
      var setView = function (mode) {
        grid.classList.toggle('ph-view--list', mode === 'list');
        views.querySelectorAll('[data-ph-view]').forEach(function (b) {
          var on = b.getAttribute('data-ph-view') === mode;
          b.classList.toggle('view--active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        try { window.localStorage.setItem('ph-coll-view', mode); } catch (err) { /* private mode */ }
      };
      if (stored === 'list') setView('list');
      views.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ph-view]');
        if (btn) setView(btn.getAttribute('data-ph-view'));
      });
    }

    /* ---- 5. Guide: "Read the full guide" reveals the remaining rows ---- */
    var more = document.querySelector('[data-ph-guide-more]');
    var card = document.querySelector('[data-ph-guide-card]');
    if (more && card) {
      var extras = Array.prototype.slice.call(card.querySelectorAll('.ph-g2__row--extra'));
      more.addEventListener('click', function () {
        var open = more.getAttribute('aria-expanded') !== 'true';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        extras.forEach(function (row) {
          if (open) row.removeAttribute('hidden');
          else { row.setAttribute('hidden', ''); row.open = false; }
        });
        if (!open) card.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }
  });
})();
